<template>
    <div class="page-header-index-wide">
        <div class="onboarding">
            <div class="head">
                <h2>Instancias</h2>
                <h3>Construyendo el primer proyecto en Linube</h3>
            </div>
            <a-row>
                <a-col :span="24" class="block-justify">
                    El área de proyectos te permite organizar y compartimentar servicios.
                        <br />
                        Dentro de un proyecto puedes configurar desde una o más redes dedicadas a uno
                        o más servicios, así como instancias, servicios de VPN o clústeres de kubernetes.
                        <br />&nbsp;<br />
                </a-col>
                </a-row>
                <a-row>
                <a-col :span="16" class="block-justify">
                    <p >
        
                        <strong> Pasos para crear un proyecto</strong>
                    <ol>
                        <li>Accede a la sección <strong class="text-linube">{{$t('label.projects')}}</strong> en el menú lateral</li>
                        <li>Haz click en <strong class="text-linube">{{ $t('label.new.project') }}</strong> y dale un nombre y descripción
                        </li>
                        <li>Haz click en <strong class="text-linube">{{ $t('label.save') }} </strong> para guardarlo</li>
                        <li>Pulsa en el icono 
                            <button class="ant-btn ant-btn-dashed ant-btn-circle ant-btn-sm ant-btn-icon-only" type="button">
                                <span role="img" aria-label="login" class="anticon anticon-login">
                                    <svg focusable="false" class="" data-icon="login" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><defs></defs><path d="M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 01520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 01270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 010 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z"></path></svg>
                                </span>
                            </button> para acceder al entorno del proyecto, o selecciona el proyecto en
                            la barra en la parte superior de la ventana <img style="max-width:300px;" src="/assets/onboarding/1-project-select.png" /></li>
                    </ol>
                    </p>
                </a-col>
                <a-col :span="8" class="block-center">
                    <img class="block-center-img" src="/assets/onboarding/0-project-new.png" />
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="24" class="block-justify">
                    <h3>Acceso al proyecto</h3>
                </a-col>
                <a-col :span="24" class="block-center">
                    <img class="block-center-img" src="/assets/onboarding/2-project-view.png" />

                </a-col>
                <a-col :span="24" class="block-justify">
                    <p >
                        Al acceder al proyecto, verás un panel de control distinto, donde aparecerán los
                        recursos asignados únicamente a éste proyecto dentro de tu cuenta. La barra lateral
                        sirve como indicador de que las instancias, redes o servicios que despliegues que hagas
                        se harán siempre dentro de los límites de éste proyecto. 
                    </p>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>

export default {
    name: 'FirstProject',
    components: {
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped lang="scss">
.onboarding {
    font-family: sans-serif;
    padding: 20px 10px 50px 10px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    @media (min-width: 760px) {
        padding: 20px 10% 50px 10%;
    }
}
.text-linube {
    color: #4DB1D9;
}
.block-center {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
}
.block-center-img {
    width: 100%;
    height: auto;
}
.block-justify {
    padding-left: 20px;
    padding-right: 20px;
    text-align: justify;
}

</style>
